<template>
	<o-tour :ref="setup._tourJobOffer">
		<o-tour-step
			:title="$t('common.shared.tour.overview.title')"
			hide-finish>
			<p>
				<b>{{ $t('common.shared.tour.overview.regularUser') }}</b> {{ $t('common.shared.tour.overview.regularUserText') }}
			</p>
			<div>
				<b>{{ $t('common.shared.tour.overview.novice') }}</b> {{ $t('common.shared.tour.overview.noviceText') }}
			</div>
		</o-tour-step>

		<o-tour-step
			:title="$t('common.shared.tour.filters.title')"
			hide-finish
			size="lg"
			:target="setup.orderListHeader.bind(setup)">
			<div>
				{{ $t('common.shared.tour.filters.quickFilters') }}
			</div>
		</o-tour-step>

		<o-tour-step
			v-if="setup.hasData"
			:title="$t('common.shared.tour.list.title')"
			size="lg"
			target="job-offer-el-0"
			hide-finish>
			<div>
				<p>
					{{ $t('common.shared.tour.list.maxElements') }}
				</p>
				<p>
					{{ $t('common.shared.tour.list.stickersContext') }}
				</p>
				{{ $t('common.shared.tour.list.hereForExample') }}
				<ul>
					<li>
						<b>{{ $t('common.shared.tour.list.employmentAgency') }}</b>
					</li>
					<li>
						{{ $t('common.shared.tour.list.qualification') }}
					</li>
					<li>
						{{ $t('common.shared.tour.list.datesLocation') }}
					</li>
					<li>
						{{ $t('common.shared.tour.list.jobDescription') }}
					</li>
					<li>
						{{ $t('common.shared.tour.list.responseStatus') }}
					</li>
				</ul>

				<p>
					{{ $t('common.shared.tour.list.notComplicated') }}
					<br>
					{{ $t('common.shared.tour.list.clickForDetails') }}
				</p>

				<i>{{ $t('common.shared.tour.list.stickerNote') }}</i> 😇
			</div>
		</o-tour-step>

		<o-tour-step
			:title="$t('common.shared.tour.tips.title')"
			size="lg">
			<p>
				{{ $t('common.shared.tour.tips.agencyTools') }}
			</p>
			<p>
				{{ $t('common.shared.tour.tips.updateProfile') }}
			</p>
			<o-alert color="info">
				<p>
					{{ $t('common.shared.tour.tips.visibilityTip') }}
				</p>
				<router-link
					class="tour-router-profile"
					:to="{ name: 'UserProfileInformations' }"
					target="_blank">
					<b>{{ $t('common.shared.tour.tips.updateProfileLink') }}</b>
				</router-link>
			</o-alert>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
// #region Setup
import type { TourJobOfferEmits, TourJobOfferProps } from './TourJobOfferSetup';
import TourJobOfferSetup from './TourJobOfferSetup';
const emits = defineEmits<TourJobOfferEmits>() as TourJobOfferEmits;
const props = withDefaults(defineProps<TourJobOfferProps>(), TourJobOfferSetup.defaultProps);
const setup = new TourJobOfferSetup(props, emits);
// #endregion
</script>
